export class FontOption {
  name: string;
  family: string;
  url: string;
}
